import { Injectable } from '@angular/core';
import {CardType, DTO, Warehouse} from '../core/entities/entities';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {HttpService} from '../core/services/http.service';
import * as Rx from 'rxjs/Rx';
import {ErrorType} from '../core/services/error.service';
import {Response} from '@angular/http';
import * as _ from 'lodash';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {isNullOrUndefined} from 'util';
export interface WarehouseQuery {
  autocomplete_warehouse_name?: string,
}



@Injectable()
export class WarehouseService extends HttpServiceBase<Warehouse> {
  public hasSingleGet(){
    return false;
  }

  public refreshOnRouteChange(){
    return false;
  }

  private _warehouseSubject: BehaviorSubject<Warehouse> = new BehaviorSubject<Warehouse>(null);
  public readonly warehouseChange: Rx.Observable<Warehouse> = this._warehouseSubject.asObservable();

  isAssociated( warehouse: Warehouse, associatedWarehouse: Warehouse ){
    return !isNullOrUndefined(warehouse) && !isNullOrUndefined(associatedWarehouse) && warehouse.id != associatedWarehouse.id && this.warehouseAssociation && !isNullOrUndefined(this.warehouseAssociation.find( wa => wa.warehouse == warehouse.id && wa.associatedWarehouse == associatedWarehouse.id));
  }
  private warehouseAssociation : {warehouse: any, associatedWarehouse: any} [] = [];
  protected init(): void {
    super.init();
    const me = this;
    me.dataChange.subscribe(() => {
        if (me.data && me.data.length > 0) {
          me.authService.isLoggedIn().subscribe(isl => {
            me.httpCall('get', this.getBasePath() + 'warehouseassociation' ,).subscribe(ret =>  me.warehouseAssociation = ret);
            if (isl && me.authService.user.warehouseId) {
              me.loadById(me.authService.user.warehouseId).subscribe(w => me.setWarehouse(w).subscribe());
            }
          });
        }
      }
    );

  }

  getCleanInstance(): Warehouse {
    return new Warehouse();
  }

  constructor(protected http: HttpService) {
    super(http);
  }

  getUrl() {
    return  'warehouse';
  }

  public fromJson(json): Warehouse {

    if(json == null) return;

    const me = this;
    const item: Warehouse = Object.assign(this.getCleanInstance(), json);

    if(json.id){
      item.code = ''+item.id;
    }

    return item;
  }

  public search(query: WarehouseQuery): Rx.Observable<Warehouse[]>{

    const me = this;
    return Rx.Observable.create((observer: any) => {
      me.httpCall('get', this.getBasePath() + 'autocomplete/warehouse' , {params: {name: query.autocomplete_warehouse_name}}).subscribe(ret =>  observer.next(me.fromJsonArray(<any[]>ret || null)));
    });
  }


  public setWarehouse(w:Warehouse): Observable<boolean>{
    const me = this;
    return Rx.Observable.create((observer: any) => {
      me.httpCall('put', this.getBasePath() + 'setwarehouse/'+w.id ).subscribe(
        ret => {
          me.loadById(w.id).subscribe(curr => me._warehouseSubject.next(curr));
          observer.next(true);
        }
      );
    });
  }




}



// WEBPACK FOOTER //
// ./src/app/services/warehouse.service.ts